<template>
  <BreadCrumb PageTitle="Liste des colis" />
  <ColisListe />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ColisListe from "../../components/Colis/ColisListe.vue";

export default defineComponent({
  name: "ColisListePage",
  components: {
    BreadCrumb,
    ColisListe,
  },
});
</script>